import type { WithdrawDetail } from '../../types/recommendation.types'
import { FolioRow } from './FolioRow'
import { HarvestingPlanType } from '../../types/summary.types'

type FolioListProps = {
  withdrawDetails?: WithdrawDetail[]
  harvestType?: HarvestingPlanType
  isFutureTax?: boolean
  isGains?: boolean
}

const BORDER_COLOR = 'border-[#F0F4F7]'

export function FolioList({ withdrawDetails, isFutureTax, isGains }: FolioListProps) {
  const list = withdrawDetails ?? []
  const count = list.length

  return (
    <div className={`bg-white rounded-[16px] pt-4 pb-4 ${BORDER_COLOR} border`}>
      <div className={`flex justify-between items-center text-[13px] font-[400] px-4 text-[#6A6E6E] pb-4 border-b ${BORDER_COLOR}`}>
        <span>{count} Folio{count !== 1 ? 's' : ''}</span>
        <span className="text-right">Withdrawal amount</span>
      </div>
      <div className="flex flex-col">
        {list.map((detail, idx) => (
          <FolioRow
            key={detail?.folioNumber ?? idx}
            detail={detail}
            showBorderAbove={idx > 0}
            isFutureTax={isFutureTax}
            isGains={isGains}
          />
        ))}
      </div>
    </div>
  )
}
